/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Title_EducationInputs */

const en_resume_title_education = /** @type {(inputs: Resume_Title_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Education`)
};

const ar_resume_title_education = /** @type {(inputs: Resume_Title_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التعليم`)
};

const bn_resume_title_education = /** @type {(inputs: Resume_Title_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`শিক্ষা`)
};

const de_resume_title_education = /** @type {(inputs: Resume_Title_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildung`)
};

const es_resume_title_education = /** @type {(inputs: Resume_Title_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Educación`)
};

const fr_resume_title_education = /** @type {(inputs: Resume_Title_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Éducation`)
};

const pt_resume_title_education = /** @type {(inputs: Resume_Title_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Educação`)
};

const zh_resume_title_education = /** @type {(inputs: Resume_Title_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`教育`)
};

const tr_resume_title_education = /** @type {(inputs: Resume_Title_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eğitim`)
};

const ru_resume_title_education = /** @type {(inputs: Resume_Title_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Образование`)
};

const pl_resume_title_education = /** @type {(inputs: Resume_Title_EducationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edukacja`)
};

/**
* | output |
* | --- |
* | "Education" |
*
* @param {Resume_Title_EducationInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const resume_title_education = /** @type {((inputs?: Resume_Title_EducationInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Title_EducationInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_resume_title_education(inputs)
	if (locale === "bn") return bn_resume_title_education(inputs)
	if (locale === "de") return de_resume_title_education(inputs)
	if (locale === "es") return es_resume_title_education(inputs)
	if (locale === "fr") return fr_resume_title_education(inputs)
	if (locale === "pt") return pt_resume_title_education(inputs)
	if (locale === "zh") return zh_resume_title_education(inputs)
	if (locale === "tr") return tr_resume_title_education(inputs)
	if (locale === "ru") return ru_resume_title_education(inputs)
	if (locale === "pl") return pl_resume_title_education(inputs)
	return en_resume_title_education(inputs)
});